/* SWSkinn — shared behaviour: menu, reveal, live Shopify availability. */
(function () {
  var btn = document.querySelector('.menu-btn');
  var drawer = document.getElementById('drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      drawer.classList.toggle('open', !open);
      document.body.style.overflow = open ? '' : 'hidden';
    });
  }

  var els = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  } else { els.forEach(function (el) { el.classList.add('in'); }); }

  // Product view event on product detail pages
  var pdp = document.querySelector('[data-pdp]');
  if (pdp && window.SW) window.SW.track('product_view', { product: pdp.getAttribute('data-pdp') });

  /* Live availability. Shopify is the source of truth; we never show a cached price or stock claim.
     If the lookup fails we say nothing about stock and still link to the product on SWSkinnShop. */
  var CAT = window.SW_CATALOGUE;
  window.SW = window.SW || {};
  window.SW.shop = (function () {
    var p = null;
    function load() {
      if (p) return p;
      // Inside the Shopify theme the layout prints live product data (window.SW_LIVE); no API call needed.
      if (window.SW_LIVE) { p = Promise.resolve({ products: window.SW_LIVE }); return p; }
      p = fetch(CAT.config.productsEndpoint, { headers: { accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { return null; });
      return p;
    }
    return { load: load };
  })();

  var stockEls = document.querySelectorAll('[data-stock]');
  if (!stockEls.length || !CAT) return;
  window.SW.shop.load().then(function (live) {
    stockEls.forEach(function (el) {
      var id = el.getAttribute('data-stock');
      var item = live && live.products && live.products[id];
      if (!item) { el.textContent = 'Available on SWSkinnShop.com'; el.dataset.state = 'unknown'; return; }
      if (item.available) {
        el.textContent = 'Available on SWSkinnShop.com';
        el.dataset.state = 'in';
      } else {
        el.textContent = 'Currently unavailable — ask us on WhatsApp';
        el.dataset.state = 'out';
        document.querySelectorAll('[data-shop-link="' + id + '"]').forEach(function (a) {
          a.firstChild.textContent = 'View on SWSkinnShop ';
          a.classList.add('btn--ghost');
        });
      }
    });
  });
})();

/* Influencer / referral codes (Shopify Collabs or discount links).
   Shopify applies a code when someone arrives via /discount/CODE or a Collabs link and stores it in the
   `discount_code` cookie; checkout then applies it automatically. We only read it to (1) confirm it to the
   customer and (2) pass it to analytics and the WhatsApp handoff so the referring influencer is known. */
(function () {
  var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
  var code = m ? decodeURIComponent(m[1]).toUpperCase().replace(/[^A-Z0-9_-]/g, '').slice(0, 40) : '';
  if (!code) return;
  window.SW = window.SW || {};
  window.SW.referralCode = code;
  var seen = false;
  try { seen = sessionStorage.getItem('sw_ref_seen') === code; sessionStorage.setItem('sw_ref_seen', code); } catch (e) {}
  if (window.SW.track && !seen) window.SW.track('referral_arrival', { code: code });
  var bar = document.createElement('div');
  bar.className = 'announce';
  bar.setAttribute('role', 'status');
  bar.textContent = 'Welcome — referred by ' + code + '. Start with your free skin analysis.';
  document.body.insertBefore(bar, document.body.firstChild);
})();
